/**
 * Utility class for array items access
 *
 * @packageDocumentation
 * @module misc/arrays
 * @preferred
 */
import IndexOutOfBoundsError from "../error/IndexOutOfBoundsError.js";
export class ArrayAccessor {
    values;
    constructor(values) {
        this.values = values;
    }
    optionalAt(index) {
        return this.values[index];
    }
    at(index) {
        if (index in this.values) {
            return this.values[index];
        }
        throw new IndexOutOfBoundsError(index, this.values.length);
    }
    get optionalLast() {
        return this.optionalAt(this.values.length - 1);
    }
    get last() {
        return this.at(this.values.length - 1);
    }
    get optionalFirst() {
        return this.optionalAt(0);
    }
    get first() {
        return this.at(0);
    }
}
export const arrayAccessor = (values) => new ArrayAccessor(values);
export default ArrayAccessor;
